import $ from 'jquery';
import BaseComponent from 'components/BaseComponent';

export default class PrimaryNavComponent extends BaseComponent {
    constructor($element, options) {
        super($element, options);

        this.init();
    }

    static defaults = {
    }

    SELECTOR = {
        TRIGGER: '[data-primaryNav-trigger]',
        MENU: '[data-primaryNav-menu]',
    }

    DATA_ATTR = {
        TRIGGER: 'data-primaryNav-trigger',
    }

    STATE = {
        ACTIVE: 's-isActive',
    }

    /**
     * Binds the scope of any handler functions.
     * Should only be run on initialization of the view.
     *
     * @method setupHandlers
     * @returns {PrimaryNavComponent}
     * @private
     */
    setupHandlers() {
        // Bind event handlers scope here
        this.onTriggerClickHander = this.onTriggerClick.bind(this);
        this.onDocumentClickHandler = this.onDocumentClick.bind(this);

        return this;
    }

    /**
     * Create any child objects or references to DOM elements.
     * Should only be run on initialization of the view.
     *
     * @method createChildren
     * @returns {PrimaryNavComponent}
     * @private
     */
    createChildren() {
        super.createChildren();

        this.$trigger = this.$element.find(this.SELECTOR.TRIGGER);
        this.$menus = this.$element.find(this.SELECTOR.MENU);

        return this;
    }

    /**
     * Remove any child objects or references to DOM elements.
     *
     * @method removeChildren
     * @returns {PrimaryNavComponent}
     * @public
     */
    removeChildren() {
        super.removeChildren();

        return this;
    }

    /**
     * Enables the component.
     * Performs any event binding to handlers.
     * Exits early if it is already enabled.
     *
     * @method enable
     * @returns {PrimaryNavComponent}
     * @public
     */
    enable() {
        if (this.isEnabled) {
            return this;
        }
        this.isEnabled = true;

        this.$trigger.on('click', this.onTriggerClickHander);
        $(document).on('click touchstart', this.onDocumentClickHandler);

        return this;
    }

    /**
     * Disables the component.
     * Tears down any event binding to handlers.
     * Exits early if it is already disabled.
     *
     * @method disable
     * @returns {PrimaryNavComponent}
     * @public
     */
    disable() {
        if (!this.isEnabled) {
            return this;
        }
        this.isEnabled = false;


        return this;
    }

    /*
        EVENT HANDLERS
    */
    onTriggerClick(e) {
        const currentMenuItem = $(e.currentTarget);
        const menuToActivate = currentMenuItem.attr(this.DATA_ATTR.TRIGGER);

        this.toggleMenuState(currentMenuItem, menuToActivate);
    }

    onDocumentClick(e) {
        if (!$(e.target).closest(this.$menus).length &&
            !$(e.target).closest(this.$trigger).length) {
            this.dismissActiveMenus();
        }
    }

    /**
     * Toggles the state of the top level menu.
     *
     * @method toggleMenuState
     * @param {Object} currentMenuItem
     * @param {String} menuToActivate
     * @public
     */
    toggleMenuState(currentMenuItem, menuToActivate) {
        if (currentMenuItem.hasClass(this.STATE.ACTIVE)) {
            currentMenuItem.removeClass(this.STATE.ACTIVE);
            this.dismissActiveMenus();

            return;
        }

        this.activateSubMenu(menuToActivate);
        currentMenuItem.addClass(this.STATE.ACTIVE)
                       .attr('aria-expanded', true);
    }

    /**
     * Activates the correct sub menu.
     *
     * @method activateSubMenu
     * @param {String} menuToActivate
     * @public
     */
    activateSubMenu(menuToActivate) {
        this.dismissActiveMenus();
        $(`[data-primaryNav-menu="${menuToActivate}"]`).addClass(this.STATE.ACTIVE);
    }

    /**
     * Resets menus to original, default state.
     *
     * @method dismissActiveMenus
     * @param {String} menuToActivate
     * @public
     */
    dismissActiveMenus() {
        this.$trigger.removeClass(this.STATE.ACTIVE)
                     .attr('aria-expanded', false);
        this.$menus.removeClass(this.STATE.ACTIVE);
    }

}
